import { isEqual, isObject, transform } from 'lodash'

export const getObjectsDifferences = <T extends Record<string, any>>(
  object: Record<string, any>,
  base: Record<string, any>,
  onlyKeys?: Array<keyof T>,
): T => {
  const changes = (
    object: Record<string, any>,
    base: Record<string, any>,
  ): Record<string, any> => {
    return transform(object, (result, value, key) => {
      if (!onlyKeys || onlyKeys.includes(key)) {
        if (!isEqual(value, base[key])) {
          result[key] =
            isObject(value) && isObject(base[key])
              ? changes(value, base[key])
              : value
        }
      }
    })
  }
  return changes(object, base) as T
}
